import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditDepartment from '../../components/departments/FormAddEditDepartment';

const CreateDepartment = () => (
    <WrapperSection>
        <GlobalBreadcrumbs />
        <FormAddEditDepartment />
    </WrapperSection>
);

export default CreateDepartment;
